export default class BackToTop {

  constructor() {
    this.selector = '';
    this.scrollTopDuration = 300;
    this.scrollOffset = 300;
  }

  init() {
    this.selector = ".back-to-top";
    this.bindClick();
    this.bindScroll();
  }

  bindClick() {
    $(this.selector).on('click', function(e){
      e.preventDefault();
      $("body, html").animate({scrollTop: 0}, this.scrollTopDuration);
    }.bind(this));
  }

  bindScroll() {
    $(window).on('scroll', function(){
      if ($(window).scrollTop() > this.scrollOffset) {
        $(this.selector).addClass("back-to-top--visible");
      } else {
        $(this.selector).removeClass("back-to-top--visible");
      }
    }.bind(this));
  }

}
